<template>
    <div class="showModal custom-modal dueModal follow-modal">
		<div @click.stop="">
            <div class="secondatyBG follow-modal-box p-4">
                <div class="follow-modal-header d-flex align-items-center justify-content-between mb-4">
                    <h3 class="f-20 px-0">{{$t('filter')}}</h3>
                    <a class="text-center" href="#" @click.prevent="$emit('close')">
                        <img src="../../../../static/website/images/x-circle.svg" alt="">
                    </a>
               </div>
               <div class="d-flex justify-content-between align-items-center">
                   <p class="f-12 text-gray">{{$t('remember_filters')}}</p>
                   <div class="wt-toggle-btn">
                       <input type="checkbox" id="switch" /><label for="switch">{{$t('toggle')}}</label>
                    </div>
                </div>
                <form class="wt-form">
                    <hr class="blackBG ">
                    <div>
                        <h3 class="f-20 px-0 mb-3">{{$t('matrix')}}</h3>
                        <div class="filter-popup-box-elem row align-items-center">
                            <div class="col-lg-4 form-check outline" v-for="item,key in leadersFilter.matrix">
                                <input class="form-check-input" type="radio" name="matrixFilter" :id="'matrix-filter'+key" :value="key" v-model="sortBy">
                                <label class="wt-form-radio " :for="'matrix-filter'+key">
                                    <span class="wt-form-radio-box"></span>
                                    <span class="form-check-label" >
                                        {{item}}
                                    </span>
                                </label>
                            </div>                         
                        </div>
                    </div>                   
                    <hr class="blackBG ">
                    <div>
                        <div class="d-flex justify-content-between mb-3">
                            <h3 class="f-20 px-0 ">{{$t('instrument')}}</h3>
                            <button class="btn btn-sm linkBG f-10">{{$t('select_all')}}</button>
                        </div>
                        <div class="filter-popup-box-elem row justify-content-between@ align-items-center">
                            <div class="col-lg-4 form-check outline" v-for="item,key in leadersFilter.instrumentList">
                                <input class="form-check-input" type="checkbox" :id="'Instruments-filter'+key" :value="key" v-model="instrumentTypes">
                                <label class="wt-form-radio" :for="'Instruments-filter'+key">
                                    <span class="wt-form-radio-box"></span>
                                    <span class="form-check-label"> {{item}} </span>
                                </label>
                            </div>                       
                        </div>
                    </div>
                    <hr class="blackBG ">
                    <div>
                        <h3 class="f-20 px-0 mb-3">{{$t('term')}}</h3>
                        <div class="filter-popup-box-elem row align-items-center gy-5">
                            <div class="col-lg-4 form-check outline" v-for="item,key in leadersFilter.timeFrameList">
                                <input class="form-check-input" type="radio" name="Terms" :id="'timeFrame-filter'+key" :value="key" v-model="timeFrame">
                                <label class="wt-form-radio" :for="'timeFrame-filter'+key">
                                    <span class="wt-form-radio-box"></span>
                                    <span class="form-check-label" >
                                        {{item}}
                                    </span>
                                </label>
                            </div>                         
                        </div>
                    </div>
                    <div class="mt-3 d-flex justify-content-center mt-5">
                        <a href="#" class="btn hover-color w-25 mr-2 black whiteBG justify-content-center d-block"  @click.prevent="clearFilter()">{{$t('clear_all')}}</a>
                        <a href="#" class="btn w-25  linkBG justify-content-center d-block" @click.prevent="submitFilter()">{{$t('apply')}}</a>
                    </div> 
               </form>
            </div>
        </div>
    </div>
</template>
<script>
    import { commonAllmixins } from "@/plugins/commonAll";
    export default{
        mixins: [commonAllmixins],
        emits:['close','submitFilter'],
        props:['filter'],
        data(){
            return{
                "sortBy": '',
                "instrumentTypes":[],
                "timeFrame": ''
            }
        },
        methods:{
            clearFilter(){
                this.sortBy = '';
                this.instrumentTypes = [];
                this.timeFrame = '';
                this.submitFilter();
            },
            submitFilter(){
                this.$emit('submitFilter',{
                    'sortBy': this.sortBy,
                    'instrumentTypes': this.instrumentTypes,
                    'timeFrame': this.timeFrame,
                });
                this.$emit('close')
            }
        },
        created(){
            this.sortBy = this.filter.sortBy;
            this.instrumentTypes = this.filter.instrumentTypes;
            this.timeFrame = this.filter.timeFrame;
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/copy-trade/filter.vue